import * as React from 'react'
import { IRecordRefTagProps, RecordRefTag } from '@utils'
import { DpWidgetContext } from './dpWidgetContext'

export const DPRecordRefTag = (props: IRecordRefTagProps) => {
  const { pageType, subPageType } = React.useContext(DpWidgetContext)
  return <RecordRefTag {...props} pageType={pageType} subPageType={subPageType}/>
}